import React, { useRef, useState, useEffect } from "react";
import "./Services.css";

const services = [
    {
        title: "AI Implementation",
        subtitle: "Practical AI for workflows",
        description:
            "AI assistants for business workflows, internal knowledge assistants, customer support or intake bots, AI-powered document processing, and AI tools connected to email, Notion, Google Drive, spreadsheets, and other business systems.",
    },
    {
        title: "AI Agent Building",
        subtitle: "OpenClaw and Hermes agents",
        description:
            "Custom agent builds on open frameworks like OpenClaw and Hermes. Self-hosted assistants that run on your own infrastructure, connect to your messaging channels and tools, and carry out multi-step work with the guardrails and approvals your business needs.",
    },
    {
        title: "AI Reception and Intake",
        subtitle: "Never miss a call or lead",
        description:
            "Virtual receptionists that answer calls and messages around the clock, screen and route enquiries, capture lead details, book appointments, and hand off a clean summary to your team. See our live receptionist in action below.",
    },
    {
        title: "Business Automation",
        subtitle: "Reduce repetitive admin work",
        description:
            "Workflow automation, admin process automation, n8n automations, email and notification systems, form-to-database workflows, invoice and report generation, and internal tools for repetitive office tasks.",
    },
    {
        title: "Website Development",
        subtitle: "Modern business websites",
        description:
            "Modern business websites, landing pages, mobile optimization, performance improvements, SEO basics, WordPress cleanup, and portfolio or business site builds.",
    },
    {
        title: "Custom Software",
        subtitle: "Tools built around your workflow",
        description:
            "Dashboards, internal admin tools, client portals, small web apps, API integrations, and database-backed tools built to match the way your business actually works.",
    },
    {
        title: "IT and Systems Consulting",
        subtitle: "Make current systems work better",
        description:
            "Digitizing paper processes, organizing files and business data, improving existing software systems, helping choose better tools, and setting up practical tech infrastructure.",
    },
    {
        title: "Support and Maintenance",
        subtitle: "Keep everything running",
        description:
            "Ongoing care for the systems we build and the ones you already have: updates and backups, monitoring and uptime checks, small feature changes, bug fixes, and a direct line for questions when something looks off.",
    },
];

export default function Services() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "Services hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="services">
            <h1 className="title">Services</h1>
            <p className="section-subtitle">
                Practical consulting and implementation support for small businesses that need better websites, better workflows, and better systems.
            </p>
            <div className="service-grid">
                {services.map((service) => (
                    <article key={service.title} className="service-card">
                        <p className="service-kicker">{service.subtitle}</p>
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}
